<div class="file-preview" [class.file-preview--with-sidebar]="showSidebar()">
  <header class="file-preview-header">
    @if (showSidebar()) {
      <button
        dataSelector="file-preview-sidebar-toggle"
        type="button"
        class="file-preview-action"
        [attr.aria-expanded]="!sidebarCollapsed()"
        [attr.aria-label]="sidebarCollapsed() ? 'Expand file list' : 'Collapse file list'"
        (click)="onToggleSidebar()"
      >
        <aiwyn-icon [height]="20" [name]="sidebarCollapsed() ? 'chevrons-right' : 'chevrons-left'" [width]="20" />
      </button>
    }

    <span class="file-preview-title h3-500" [title]="currentFile()?.name">{{ currentFile()?.name }}</span>

    <div class="file-preview-actions">
      @if (canDownload) {
        <button
          dataSelector="file-preview-download"
          aria-label="Download file"
          type="button"
          class="file-preview-action"
          (click)="onDownload()"
        >
          <aiwyn-icon name="download" [height]="20" [width]="20" />
        </button>
        @if (currentRenderer() === 'apryse') {
          <button
            dataSelector="file-preview-print"
            aria-label="Print file"
            type="button"
            class="file-preview-action"
            [disabled]="printDisabled()"
            (click)="onPrint()"
          >
            @if (isPrinting()) {
              <mat-spinner diameter="18" />
            } @else {
              <aiwyn-icon name="printer" [height]="20" [width]="20" />
            }
          </button>
        }
        <span aria-hidden="true" class="file-preview-divider"></span>
      }
      <button dataSelector="file-preview-close" aria-label="Close preview" type="button" class="file-preview-action" (click)="onClose()">
        <aiwyn-icon name="x" [height]="20" [width]="20" />
      </button>
    </div>
  </header>

  <div class="file-preview-body">
    @if (showSidebar()) {
      <div class="file-preview-sidebar" [class.file-preview-sidebar--collapsed]="sidebarCollapsed()">
        <app-file-preview-sidebar [currentIndex]="currentIndex()" [files]="files()" (fileSelected)="onSelectFile($event)" />
      </div>
    }

    <main class="file-preview-viewer">
      @switch (currentRenderer()) {
        @case ('apryse') {
          @if (loadError()) {
            <app-error-renderer [message]="loadErrorMessage()" (retry)="onRetry()" />
          } @else if (isLoadedDocCurrent()) {
            <app-apryse-renderer
              [file]="loadedFile()!"
              [source]="loadedSource()!"
              [canDownload]="canDownload"
              (documentLoaded)="onRendererDocumentLoaded($event)"
              (loadError)="onRendererLoadError($event)"
              (loadingProgress)="onRendererLoadingProgress($event)"
            />
          }

          @if (isLoading()) {
            <div class="file-preview-loading file-preview-loading--overlay">
              @if (progressPercent() !== null) {
                <mat-progress-spinner [value]="progressPercent()!" diameter="48" mode="determinate" />
                @if (progressLabel()) {
                  <span dataSelector="file-preview-progress-label" class="file-preview-loading-label">{{ progressLabel() }}</span>
                }
              } @else {
                <mat-spinner diameter="48" />
              }
            </div>
          }
        }
        @case ('unsupported') {
          <app-unsupported-renderer [file]="currentFile()!" [canDownload]="canDownload" (download)="onDownload()" />
        }
      }
    </main>
  </div>
</div>
